export type SetDynamicListingAction = {type: "SET_DYNAMIC_LISTING", data: boolean};

type State = {
  isDynamicListing: boolean,
};

const initialState: State = {
  isDynamicListing: false,
};

export function dynamicListing(state: State = initialState, action: Action): State {
  switch (action.type) {
    case 'SET_DYNAMIC_LISTING':
      return { ...state, isDynamicListing: !!action.data };
    default:
      return state;
  }
}
